module.exports = __webpack_public_path__ + "img/platform-personal-32.0f6a9230.svg";